import { createSelector } from 'reselect'

import { userHasOrgConversationReports } from 'utils/access'
import { rootSelector } from 'utils/redux'

import { FilterState } from './types'

export const filterRootSelector = rootSelector<FilterState>('filter')

const filterSelector = <K extends keyof FilterState>(key: K) =>
  createSelector<{ filters: FilterState }, FilterState, FilterState[K]>(
    filterRootSelector,
    (filter) => filter[key]
  )

const agentsSelectedSelector = createSelector(
  filterRootSelector,
  (state) => state.user,
  (filter, user) => {
    return userHasOrgConversationReports()
      ? filter.agentsSelected
      : [{ value: user.id }]
  }
)

export const timePeriod = filterSelector('timePeriod')
export const advancedFilters = filterSelector('advancedFilters')
export const botStatus = filterSelector('botStatus')
export const widgetStatus = filterSelector('widgetStatus')
export const agentsSelected = agentsSelectedSelector
export const inboxSelected = filterSelector('inboxSelected')
export const teamSelected = filterSelector('teamSelected')
export const workspaceSelected = filterSelector('workspaceSelected')
export const workspaceAgents = filterSelector('workspaceAgents')
export const teammateEmailSelected = filterSelector('teammateEmailSelected')
export const selectedClassificationId = filterSelector(
  'selectedClassificationId'
)
export const automationPlaybookSelected = filterSelector(
  'automationPlaybookSelected'
)
export const compoundFilter = filterSelector('compoundFilter')
export const compoundQuery = filterSelector('compoundQuery')
